import { ReactNode } from 'react';

import classNames from 'classnames';

import useStyles from './List.styles';

/**
 * Свойства компонента {@link List}
 */
export interface ListProps {
  /**
   * Стиль маркера для элементов списка.
   *
   * @defaultValue `'none'`
   */
  listStyleType?: string;

  /**
   * Левое поле (pl) для списка.
   *
   * @defaultValue `0`
   */
  pl?: number;

  /**
   * Дочерние элементы списка. Обычно это элементы `<li>`.
   */
  children: ReactNode;
}

/**
 * Пользовательский компонент неупорядоченного списка.
 *
 * @public
 * @param listStyleType - Стиль маркера для элементов списка.
 * @param pl - Левое поле (pl) для списка.
 * @param children - Дочерние элементы списка.
 * @returns  Элемент неупорядоченного списка с применёнными стилями.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ListProps}
 */
export const List = ({
  listStyleType = 'none',
  pl = 0,
  children,
}: ListProps) => {
  const { classes } = useStyles({ listStyleType, pl });

  return <ul className={classNames(classes.list, 'aqa_list')}>{children}</ul>;
};
